import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import HighwayUnpaidAbout from '@di-shared/features/public-service/highway-unpaid/HighwayUnpaidAbout';

export interface HighwayUnpaidAboutPageProps {
  vin: string;
}

function HighwayUnpaidAboutPage({vin}: HighwayUnpaidAboutPageProps) {
  return (
    <>
      <ScrollToTopOnMount />
      <HighwayUnpaidAbout vin={vin} />
    </>
  );
}

export default HighwayUnpaidAboutPage;
